import { render } from "./PeriodOverview.vue?vue&type=template&id=1b792458"
import script from "./PeriodOverview.vue?vue&type=script&lang=js"
export * from "./PeriodOverview.vue?vue&type=script&lang=js"

import "./PeriodOverview.vue?vue&type=style&index=0&id=1b792458&lang=scss"
script.render = render

export default script